import {
  login,
  register,
  resetPassword,
  passwordLessLogin,
  changePassword,
  loginByState,
  loginByCode,
} from "@/api/account";
import Storage from "@/utils/storage";
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim();
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}
const user = {
  state: {
    apiToken: "",
    identityToken: "",
    userInfo: {},
  },

  mutations: {
    SET_API_TOKEN: (state, apiToken) => {
      state.apiToken = apiToken;
    },
    SET_IDENTITY_TOKEN: (state, identityToken) => {
      state.identityToken = identityToken;
    },
    SET_USER_INFO: (state, userInfo) => {
      state.userInfo = userInfo;
    },
  },

  actions: {
    UpdateIdentityToken({ commit }, identityToken) {
      return new Promise((resolve) => {
        commit("SET_IDENTITY_TOKEN", identityToken);
        Storage.set("identityToken", identityToken);
        resolve();
      });
    },

    UpdateUserInfo({ commit }, userInfo) {
      return new Promise((resolve) => {
        commit("SET_USER_INFO", userInfo);
        Storage.set("userInfo", userInfo);
        resolve();
      });
    },

    // 账号密码登录
    LoginByUsername({ commit }, loginInfo) {
      const account = loginInfo.account.trim();
      return new Promise((resolve, reject) => {
        login(
          account,
          loginInfo.password,
          loginInfo.language,
          loginInfo.apptype
        )
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              commit("SET_USER_INFO", res.data.user);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              Storage.set("userInfo", res.data.user);
              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },
    // 免密登录
    PasswordLessLogin({ commit }, loginInfo) {
      return new Promise((resolve, reject) => {
        passwordLessLogin(loginInfo)
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              commit("SET_USER_INFO", res.data.user);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              Storage.set("userInfo", res.data.user);
              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },

    // 注册
    Register({ commit }, registerInfo) {
      return new Promise((resolve, reject) => {
        register(registerInfo)
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              commit("SET_USER_INFO", res.data.user);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              Storage.set("userInfo", res.data.user);
              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },

    // 重置密码
    ResetPassword({ commit }, postData) {
      return new Promise((resolve, reject) => {
        resetPassword(postData)
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              commit("SET_USER_INFO", res.data.user);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              Storage.set("userInfo", res.data.user);
              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },

    // 修改密码
    ChangePassword({ commit }, postData) {
      return new Promise((resolve, reject) => {
        changePassword(postData)
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },

    // 登出
    Logout({ commit }) {
      return new Promise((resolve) => {
        commit("SET_API_TOKEN", "");
        commit("SET_IDENTITY_TOKEN", "");
        commit("SET_USER_INFO", {});
        Storage.set("apiToken", null);
        Storage.set("identityToken", null);
        Storage.set("userInfo", null);
        resolve();
      });
    },

    // token登录
    LoginByToken({ commit }, data) {
      return new Promise((resolve, reject) => {
        if (data && data.api_token && data.identity_token && data.user) {
          commit("SET_API_TOKEN", data.api_token);
          commit("SET_IDENTITY_TOKEN", data.identity_token);
          commit("SET_USER_INFO", data.user);
          Storage.set("apiToken", data.api_token);
          Storage.set("identityToken", data.identity_token);
          Storage.set("userInfo", data.user);
          resolve();
        } else {
          reject(new Error("Failed to sync login token"));
        }
      });
    },

    /**
     * 同步登陆状态
     */
    SyncLoginState({ commit }, data) {
      return new Promise((resolve, reject) => {
        if (data && data.api_token && data.identity_token && data.user) {
          commit("SET_API_TOKEN", data.api_token);
          commit("SET_IDENTITY_TOKEN", data.identity_token);
          commit("SET_USER_INFO", data.user);
          Storage.set("apiToken", data.api_token);
          Storage.set("identityToken", data.identity_token);
          Storage.set("userInfo", data.user);
          resolve();
        } else {
          reject(new Error("Failed to sync login state"));
        }
      });
    },

    // 第三方登录
    LoginByState({ commit }, state) {
      return new Promise((resolve, reject) => {
        loginByState(state)
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              commit("SET_USER_INFO", res.data.user);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              Storage.set("userInfo", res.data.user);
              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },

    // 微信code登录
    LoginByCode({ commit }, code) {
      return new Promise((resolve, reject) => {
        loginByCode(code)
          .then((res) => {
            if (res && res.status === 200) {
              commit("SET_API_TOKEN", res.data.api_token);
              commit("SET_IDENTITY_TOKEN", res.data.identity_token);
              commit("SET_USER_INFO", res.data.user);
              Storage.set("apiToken", res.data.api_token);
              Storage.set("identityToken", res.data.identity_token);
              Storage.set("userInfo", res.data.user);

              // GA注册事件使用 by harry
              let userCreatedAt = res.data.user.created_at || 0;
              let userLastLoginTime = res.data.user.last_login_time || 0;
              // 当用户创建时间 === 最近一次登录时间 的时候，认为是新用户，需要发送注册转化事件
              if (
                userCreatedAt &&
                userLastLoginTime &&
                userCreatedAt === userLastLoginTime
              ) {
                let event = new CustomEvent("wx_user_register_complete", {
                  detail: {
                    country: res.data.user.region,
                    id: res.data.user.user_id,
                    apptype: getCookie("apptype"),
                  },
                });
                window.dispatchEvent(event);
              }

              resolve();
            } else if (res && res.status) {
              reject(res.status);
            }
          })
          .catch((error) => {
            if (error && error.status) {
              reject(error.status);
            }
          });
      });
    },
  },
};

export default user;
